// Global receipt builder — WhatsApp fişini istenilen dilde yeniden üretir.
// POS.jsx ilk kez inşa ederken de, WhatsAppReceiptModal içindeki dil-seçim
// menüsü değiştiğinde de aynı fonksiyon çağrılır. TR / EN / AR / DE / RU
// desteği. Tüm sayısal formatlar (para, gram) Intl.NumberFormat ile
// locale-aware.

const LANGS = ["tr", "en", "ar", "de", "ru"];

const LANG_LOC = { tr: "tr-TR", en: "en-US", ar: "ar-SA", de: "de-DE", ru: "ru-RU" };

// Kullanıcının UI dili (fallback → tr)
export const currentUiLang = () => {
  try {
    const v = localStorage.getItem("uc_lang") || "tr";
    return LANGS.includes(v) ? v : "tr";
  } catch { return "tr"; }
};

// Bayrak + kısa etiket — modal picker'da kullanılır
export const LANG_META = {
  tr: { flag: "🇹🇷", label: "Türkçe",   short: "TR" },
  en: { flag: "🇬🇧", label: "English",  short: "EN" },
  ar: { flag: "🇸🇦", label: "العربية",  short: "AR" },
  de: { flag: "🇩🇪", label: "Deutsch",  short: "DE" },
  ru: { flag: "🇷🇺", label: "Русский",  short: "RU" },
};

// Her etiketin 5 dildeki karşılığı — fiş metninin sözlüğü
const STRINGS = {
  tr: { adBanner:"Detaylı Analiz & Canlı Kurlar", docTitle:"Resmi İşlem Belgesi", docNo:"Belge No", customer:"Müşteri", payment:"Ödeme", itemsHeader:"ÜRÜN DETAYLARI", karat:"Ayar", weight:"Gramaj", qty:"Adet", unitPrice:"Br.Fiyat", perGr:"gr", subtotal:"Tutar", totalPure:"Toplam Has Karşılığı", scrapHeader:"HURDA / BOZUK ALIM", rawGram:"Ham Gramaj", pureEq:"Has Karşılığı", base:"Taban Bedel", marginPct:"Alım Kârı", manualTag:"Pazarlık", grandTotal:"GENEL TOPLAM", thanks:"Bizi tercih ettiğiniz için teşekkür ederiz.", taxNo:"V.D./VKN", poweredBy:"Powered by MİLYEMSOFT", pay:{ cash:"Nakit", card:"Kredi Kartı", transfer:"Havale/EFT" } },
  en: { adBanner:"Live Rates & Detailed Analytics", docTitle:"Official Transaction Receipt", docNo:"Receipt No", customer:"Customer", payment:"Payment", itemsHeader:"PRODUCT DETAILS", karat:"Karat", weight:"Weight", qty:"Qty", unitPrice:"Unit Price", perGr:"gr", subtotal:"Amount", totalPure:"Total Pure Gold Eq.", scrapHeader:"SCRAP GOLD PURCHASE", rawGram:"Raw Weight", pureEq:"Pure Gold Eq.", base:"Base Value", marginPct:"Buying Margin", manualTag:"Negotiated", grandTotal:"GRAND TOTAL", thanks:"Thank you for choosing us.", taxNo:"Tax ID", poweredBy:"Powered by MİLYEMSOFT", pay:{ cash:"Cash", card:"Credit Card", transfer:"Bank Transfer" } },
  ar: { adBanner:"أسعار مباشرة وتحليل مفصّل", docTitle:"إيصال معاملة رسمي", docNo:"رقم الإيصال", customer:"العميل", payment:"الدفع", itemsHeader:"تفاصيل المنتج", karat:"العيار", weight:"الوزن", qty:"العدد", unitPrice:"سعر الوحدة", perGr:"غ", subtotal:"المبلغ", totalPure:"إجمالي ذهب صافٍ", scrapHeader:"شراء خردة الذهب", rawGram:"الوزن الخام", pureEq:"معادل ذهب صافٍ", base:"القيمة الأساسية", marginPct:"هامش الشراء", manualTag:"تفاوض", grandTotal:"الإجمالي الكلي", thanks:"شكراً لاختياركم لنا.", taxNo:"الرقم الضريبي", poweredBy:"مدعوم من MİLYEMSOFT", pay:{ cash:"نقداً", card:"بطاقة ائتمان", transfer:"حوالة بنكية" } },
  de: { adBanner:"Live-Kurse & Detailanalyse", docTitle:"Offizieller Transaktionsbeleg", docNo:"Beleg-Nr.", customer:"Kunde", payment:"Zahlung", itemsHeader:"PRODUKTDETAILS", karat:"Karat", weight:"Gewicht", qty:"Menge", unitPrice:"Einzelpreis", perGr:"g", subtotal:"Betrag", totalPure:"Feingold-Äquivalent", scrapHeader:"ALTGOLD-ANKAUF", rawGram:"Rohgewicht", pureEq:"Feingold-Äq.", base:"Grundwert", marginPct:"Ankaufsmarge", manualTag:"Verhandelt", grandTotal:"GESAMTBETRAG", thanks:"Vielen Dank für Ihren Besuch.", taxNo:"USt-IdNr.", poweredBy:"Bereitgestellt von MİLYEMSOFT", pay:{ cash:"Bargeld", card:"Kreditkarte", transfer:"Überweisung" } },
  ru: { adBanner:"Живые курсы и детальная аналитика", docTitle:"Официальный чек операции", docNo:"№ чека", customer:"Клиент", payment:"Оплата", itemsHeader:"ДЕТАЛИ ТОВАРА", karat:"Проба", weight:"Вес", qty:"Кол-во", unitPrice:"Цена ед.", perGr:"г", subtotal:"Сумма", totalPure:"Эквивалент чистого золота", scrapHeader:"СКУПКА ЛОМА", rawGram:"Сырой вес", pureEq:"Экв. чистого золота", base:"Базовая сумма", marginPct:"Маржа скупки", manualTag:"Договорная", grandTotal:"ИТОГО", thanks:"Спасибо, что выбрали нас.", taxNo:"ИНН", poweredBy:"Работает на MİLYEMSOFT", pay:{ cash:"Наличные", card:"Кредитная карта", transfer:"Банковский перевод" } },
};

const DIV_FULL = "━━━━━━━━━━━━━━━━━━━━━━━━━";
const DIV_DOT  = "──────────────────────────";

const ayar = (purity) => {
  const p = Number(purity || 0);
  if (!p) return "—";
  const m = Math.round(p * 1000);
  const map = { 999:"24K", 916:"22K", 750:"18K", 585:"14K", 417:"10K", 925:"925", 950:"950" };
  return map[m] || `${m}‰`;
};

/**
 * Fiş metnini üret.
 * @param {object} lastTxn      POS.jsx içindeki lastTxn objesi
 * @param {string} shopName
 * @param {object} shopMeta     { address, phone, tax_no, footer }
 * @param {string} lang         tr | en | ar | de | ru
 */
export function buildReceiptText(lastTxn, shopName, shopMeta, lang) {
  if (!lastTxn) return "";
  const key = LANGS.includes(lang) ? lang : "tr";
  const L = STRINGS[key];
  const loc = LANG_LOC[key];

  const dateStr = new Intl.DateTimeFormat(loc, { dateStyle:"long", timeStyle:"short" }).format(new Date(lastTxn.date));
  const fmtCur = (v) => new Intl.NumberFormat(loc, { style:"currency", currency:"TRY", maximumFractionDigits:2 }).format(Number(v)||0);
  const fmtGr  = (v) => new Intl.NumberFormat(loc, { maximumFractionDigits:4 }).format(Number(v)||0) + " " + L.perGr;
  const num4   = (v) => new Intl.NumberFormat(loc, { maximumFractionDigits:4 }).format(Number(v)||0);
  const payLabel = L.pay[lastTxn.payment] || lastTxn.payment;

  const lines = [];
  lines.push(DIV_FULL);
  lines.push(`🌐 *${L.adBanner}*`);
  lines.push(`   www.milyemsoft.com`);
  lines.push(DIV_FULL);
  lines.push(``);

  lines.push(`💎 *${(shopName||"").toUpperCase()}*`);
  lines.push(`📜 *${L.docTitle}*`);
  lines.push(DIV_FULL);
  lines.push(`🧾  ${L.docNo}: *${(lastTxn.id || "").slice(0,8).toUpperCase()}*`);
  lines.push(`📅  ${dateStr}`);
  if (lastTxn.customerName) lines.push(`👤  ${lastTxn.customerName}`);
  lines.push(`💳  ${L.payment}: *${payLabel}*`);
  lines.push(DIV_FULL);
  lines.push(``);

  if (lastTxn.kind === "sale") {
    lines.push(`*${L.itemsHeader}*`);
    lines.push(DIV_DOT);
    for (const x of (lastTxn.items || [])) {
      const unitPerG = x._weight ? (Number(x.unit_price) / Number(x._weight)) : 0;
      lines.push(`▸ *${x.name}*`);
      lines.push(`   ${L.karat}      : ${ayar(x._purity)}`);
      lines.push(`   ${L.weight}    : ${num4(x._weight)} ${L.perGr}`);
      lines.push(`   ${L.qty}       : ${x.quantity}`);
      lines.push(`   ${L.unitPrice} : ${fmtCur(x.unit_price)}${unitPerG ? `  ( ${fmtCur(unitPerG)}/${L.perGr} )` : ""}`);
      lines.push(`   ${L.subtotal}  : *${fmtCur(x.total)}*`);
      lines.push(DIV_DOT);
    }
    lines.push(``);
    lines.push(`⚖️  ${L.totalPure}:  *${fmtGr(lastTxn.gram)}*`);
  } else {
    lines.push(`♻️ *${L.scrapHeader}*`);
    lines.push(DIV_DOT);
    lines.push(`   ${L.rawGram}   : ${num4(lastTxn.rawGram)} ${L.perGr}`);
    lines.push(`   ${L.karat}     : ${ayar(lastTxn.purity)}`);
    lines.push(`   ${L.pureEq}    : *${fmtGr(lastTxn.gram)}*`);
    if (lastTxn.base && lastTxn.base > 0) {
      lines.push(`   ${L.base}     : ${fmtCur(lastTxn.base)}`);
    }
    if (typeof lastTxn.marginPct === "number") {
      lines.push(`   ${L.marginPct}  : %${lastTxn.marginPct.toFixed(2)}${lastTxn.manual ? `  (${L.manualTag})` : ""}`);
    }
    lines.push(DIV_DOT);
  }

  lines.push(``);
  lines.push(DIV_FULL);
  lines.push(`💰 *${L.grandTotal}:*  *${fmtCur(lastTxn.total)}*`);
  lines.push(DIV_FULL);
  lines.push(``);

  lines.push(`🙏 *${L.thanks}*`);
  lines.push(``);
  lines.push(`🏛️  *${shopName}*`);
  if (shopMeta?.address) lines.push(`📍  ${shopMeta.address}`);
  if (shopMeta?.phone)   lines.push(`☎️   ${shopMeta.phone}`);
  if (shopMeta?.tax_no)  lines.push(`🧾  ${L.taxNo}: ${shopMeta.tax_no}`);
  if (shopMeta?.footer)  lines.push(`   ${shopMeta.footer}`);

  lines.push(``);
  lines.push(DIV_FULL);
  lines.push(`_${L.poweredBy}_`);
  lines.push(`🌐 www.milyemsoft.com`);
  lines.push(DIV_FULL);

  return lines.join("\n");
}

export { LANGS };
